/**
 * Presentation-only categorical counting over already-fetched rows (e.g.
 * "how many rows have status X"). This is a tally, not a business
 * calculation - it derives no financial value and reads no field beyond
 * what the backend already returned.
 */
export function tallyBy<T>(rows: T[], key: (row: T) => string): Record<string, number> {
  const counts: Record<string, number> = {};
  for (const row of rows) {
    const value = key(row);
    counts[value] = (counts[value] ?? 0) + 1;
  }
  return counts;
}
